export default __webpack_public_path__ + "static/media/graphic-1-mobile.639adf71.png";